/* eslint-disable */
export default {
    profile_highest_advanced_education_level: "Quel est votre plus haut niveau d’études dans l’enseignement supérieur ou professionnel ?",
    profile_highest_basic_education_level: "Quel est votre plus haut niveau d’études dans l’enseignement secondaire ?",
    profile_date_of_birth: "Date de naissance",
    profile_gender: "Sexe",
    profile_unexpected_error: "Une erreur s'est produite. Veuillez réessayer.",
    profile_check_your_details_intro: "Vérifiez vos données et modifiez-les si nécessaire",
    profile_check_your_details_title: "Vos données personnelles",
    profile_check_your_details_save: "Sauvegarder & continuer",
    profile_update_personal_data_error: "Une erreur s'est produite lors de la mise à jour des données personnelles. Veuillez réessayez plus tard.",
    profile_update_details_could_not_fetch_form_fields: "Une erreur s'est produite lors de la récupération du formulaire avec l'identifiant :",
    profile_feature_toggles_page_title: "Feature toggles",
    profile_update_details_success: "Le profil a été mis à jour avec succès",
    profile_cv_section_modal_title: "Supprimer le fichier",
    profile_cv_section_modal_body: "Voulez-vous vraiment supprimer ce fichier ?",
    profile_cv_section_modal_cancel: "Annuler",
    profile_cv_section_modal_confirm: "Supprimer",
    profile_cv_section_title: "Télécharger le CV",
    profile_cv_section_body: "Nous vous demandons de télécharger votre CV. Le CV sera utilisé comme entrée en matière pour l'entretien avec votre conseiller LTP, si cela s'applique à vous.",
    profile_education_title: "Éducation",
    profile_cv_section_delete_error: "Une erreur s'est produite lors de la suppression du fichier. Veuillez réessayez plus tard.",
    profile_cv_section_delete_success: "Le fichier a été supprimé avec succès.",
    profile_cv_section_upload_error: "Impossible de télécharger le fichier, veuillez réessayer plus tard.",
    profile_cv_section_download_error: "Impossible de télécharger le fichier, veuillez réessayer plus tard.",
    profile_general_error: "Une erreur s'est produite. Veuillez réessayez plus tard.",
    profile_update_details_failed: "Une erreur s'est produite lors de l'enregistrement des données.",
    profile_cv_section_upload_too_large: "Le fichier est plus volumineux que le maximum autorisé de 5 Mo.",
    profile_date_of_birth_question: "Quelle est vous date de naissance?",
    profile_amend_details_submit_button: "Au programme",
    profile_date_of_birth_invalid_format: "The format must be DD-MM-YYYY",
    profile_education_level_option_none: "None",
    profile_education_level_option_primary_education: "Primary education",
    profile_education_level_option_high_school: "High school",
    profile_education_level_option_vocational: "Vocational school",
    profile_education_level_option_college: "College",
    profile_education_level_option_university: "University",
    profile_education_level_option_phd: "PhD",
    profile_education_level_option_geen: "Geen",
    profile_education_level_option_havo: "Havo",
    profile_education_level_option_mavo_vmbo: "Mavo/vmbo",
    profile_education_level_option_praktijkonderwijs: "Praktijkonderwijs",
    profile_education_level_option_vwo: "Vwo",
    profile_education_level_option_hbo: "HBO",
    profile_education_level_option_mbo1: "MBO 1",
    profile_education_level_option_mbo2: "MBO 2",
    profile_education_level_option_mbo3: "MBO 3",
    profile_education_level_option_mbo4: "MBO 4",
    profile_education_level_option_bachelor: "WO bachelor",
    profile_education_level_option_master: "WO master",
    profile_select_active_competencies_label: "Which competencies would you like to measure? (min. 1)",
    profile_education_level_option_other: "Autre",
    profile_language_fluency_level: "Veuillez indiquer votre niveau de maîtrise de",
    profile_language_fluency_level_primary: "Langue maternelle / bilingue",
    profile_language_fluency_level_full_professional: "Courant",
    profile_language_fluency_level_professional_working: "Bon niveau",
    profile_language_fluency_level_limited_working: "Niveau limité",
    profile_language_fluency_level_elementary: "Niveau élémentaire",
    profile_Language_fluency_level_limited_proficiency: "Niveau limité",
    profile_Language_fluency_level_proficient: "Bon niveau",
    profile_Language_fluency_level_fluent: "Courant",
    profile_Language_fluency_level_secondary: "Bilingue ou multilingue avec le français comme deuxième langue",
    profile_Language_fluency_level_native: "Langue maternelle, le français est la première langue",
    profile_amend_details_submit_without_cv_button: "Continuer sans CV"
};
